// src/App.js
import React, { useState, useEffect } from 'react';
import { Layout } from 'antd';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import Services from './components/Services/Services';
import ClientsPartners from './components/ClientsPartners/ClientsPartners';
import AboutUs from './components/AboutUs/AboutUs';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import Loader from './components/Loader/Loader';
import './App.css';

const { Content } = Layout;

function App() {
  const [currentSection, setCurrentSection] = useState('home');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate page loading
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2500); // Adjust this time as needed

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['home', 'services', 'clients-partners', 'about-us', 'contact'];
      const scrollPosition = window.scrollY + 100;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const offsetTop = element.offsetTop;
          const offsetBottom = offsetTop + element.offsetHeight;

          if (scrollPosition >= offsetTop && scrollPosition < offsetBottom) {
            setCurrentSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 80, // Adjust for header height
        behavior: 'smooth'
      });
    }
  };

  return (
    <>
      {loading && <Loader />}
      <Layout className="layout" style={{ opacity: loading ? 0 : 1, transition: 'opacity 0.5s ease-in' }}>
        <Header currentSection={currentSection} scrollToSection={scrollToSection} />
        <Content>
          <div id="home">
            <Hero />
          </div>
          <div id="services">
            <Services />
          </div>
          <div id="clients-partners">
            <ClientsPartners />
          </div>
          <div id="about-us">
            <AboutUs />
          </div>
          <div id="contact">
            <Contact />
          </div>
        </Content>
        <Footer />
      </Layout>
    </>
  );
}

export default App;